import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import sampleVendors from "../data/sampleVendors";

const toMs = (ts) =>
  ts && ts.toMillis ? ts.toMillis() : ts && ts.seconds ? ts.seconds * 1000 : null;

// Active and not past its paid period.
export const isLive = (v) => {
  if (v.paidUntil == null) return true;
  const ms = toMs(v.paidUntil);
  return ms == null ? true : ms > Date.now();
};

// Boosted and not past its boost period.
export const isFeatured = (v) => {
  if (!v.featured) return false;
  if (v.featuredUntil == null) return true;
  const ms = toMs(v.featuredUntil);
  return ms == null ? true : ms > Date.now();
};

// Order: boosted (most days first) → premium → basic. Stable otherwise.
const tierRank = (v) => (v.tier === "premium" ? 1 : 0);
const sortFeatured = (list) =>
  [...list].sort((a, b) => {
    const fa = isFeatured(a);
    const fb = isFeatured(b);
    if (fa !== fb) return fa ? -1 : 1;
    if (fa && fb) return (b.featuredDays || 0) - (a.featuredDays || 0);
    const ta = tierRank(a);
    const tb = tierRank(b);
    if (ta !== tb) return tb - ta;
    return 0;
  });

export default function useVendors() {
  const [vendors, setVendors] = useState(() => sortFeatured(sampleVendors));

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const q = query(collection(db, "vendors"), where("isActive", "==", true));
        const snap = await getDocs(q);
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() })).filter(isLive);
        if (active && list.length) setVendors(sortFeatured(list));
      } catch (err) {
        console.warn("Using sample vendors (Firestore not reachable):", err.message);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return vendors;
}
